// extracted by mini-css-extract-plugin
export default {"theme":"ThemeDark__theme-kfVx","mw-i":"ThemeDark__mw-i-xHed"};